export default __webpack_public_path__ + "static/media/join_us_xl.7202cc78.jpg";